import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionsOverview } from "@/components/calv/RegionsOverview";

export const Route = createFileRoute("/en/regions/")({
  head: () => {
    const h = pageHead("regions", "en");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionsOverview locale="en" />,
});
